import { render, staticRenderFns } from "./Ulotka.vue?vue&type=template&id=38f21eb3&"
import script from "./Ulotka.vue?vue&type=script&lang=js&"
export * from "./Ulotka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports